export default "__VITE_ASSET__a9b840b1__"